import { Injectable } from '@angular/core';
import { DpCheckBoxMode, DpFieldCheckbox, DpFieldCustomLabel, DpFieldGroup, DpFieldNumber, DpFieldText, DpFormRow, DpSection, DpSectionForm, DpSectionIcon } from '@docpath/webcomponents';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { Constants } from 'src/app/constants/constants';

@Injectable({
    providedIn: 'root'
})
export class SelfMaintenanceFormService {

    getSectionForm(): DpSectionForm {
        return new DpSectionForm({
            sections: [this.getSection()],
            i18nPrefix: 'self-maintenance.form',
            sectionIcon: new DpSectionIcon(faCog)
        });
    }

    private getSection(): DpSection {
        return new DpSection({
            name: 'config',
            rows: [
                new DpFormRow([
                    new DpFieldCheckbox({
                        name: Constants.CONF_SELF_MAINTENANCE_ENABLE,
                        requiredFields: [
                            Constants.CONF_SELF_MAINTENANCE_START_MAINTENANCE,
                            Constants.CONF_SELF_MAINTENANCE_ENABLE_REMOVE_LOG,
                            Constants.CONF_SELF_MAINTENANCE_ENABLE_REMOVE_DATA,
                            Constants.CONF_SELF_MAINTENANCE_ENABLE_REMOVE_JOB
                        ],
                        column: 4,
                        mode: DpCheckBoxMode.Switch
                    }),
                    new DpFieldText({ name: Constants.CONF_SELF_MAINTENANCE_START_MAINTENANCE, column: 1, required: true })
                ]),
                new DpFormRow([
                    new DpFieldCustomLabel({ name: '', labelColumn: 1 }),
                    new DpFieldCheckbox({ name: Constants.CONF_SELF_MAINTENANCE_ENABLE_REMOVE_LOG, column: 6, requiredFields: [Constants.CONF_SELF_MAINTENANCE_DAYS_KEEP_LOG] }),
                    new DpFieldGroup({
                        labelHidden: true,
                        fields: [
                            new DpFieldNumber({ name: Constants.CONF_SELF_MAINTENANCE_DAYS_KEEP_LOG, column: 1, min: 1, labelHidden: true, required: true, placeholder: '0' }),
                            new DpFieldText({ name: 'days', disabled: true })
                        ],
                        column: 2
                    })                    
                ]),                
                new DpFormRow([
                    new DpFieldCustomLabel({ name: '', labelColumn: 1 }),
                    new DpFieldCheckbox({ name: Constants.CONF_SELF_MAINTENANCE_ENABLE_REMOVE_DATA, column: 6, requiredFields: [Constants.CONF_SELF_MAINTENANCE_DAYS_KEEP_DATA] }),
                    new DpFieldGroup({
                        labelHidden: true,
                        fields: [
                            new DpFieldNumber({ name: Constants.CONF_SELF_MAINTENANCE_DAYS_KEEP_DATA, column: 1, min: 1, labelHidden: true, required: true, placeholder: '0' }),
                            new DpFieldText({ name: 'days', disabled: true })
                        ],
                        column: 2
                    })
                ]),                
                new DpFormRow([
                    new DpFieldCustomLabel({ name: '', labelColumn: 1 }),
                    new DpFieldCheckbox({ name: Constants.CONF_SELF_MAINTENANCE_ENABLE_REMOVE_JOB, column: 6, requiredFields: [Constants.CONF_SELF_MAINTENANCE_DAYS_KEEP_JOB] }),
                    new DpFieldGroup({
                        labelHidden: true,
                        fields: [
                            new DpFieldNumber({ name: Constants.CONF_SELF_MAINTENANCE_DAYS_KEEP_JOB, column: 1, min: 1, labelHidden: true, required: true, placeholder: '0' }),
                            new DpFieldText({ name: 'days', disabled: true })
                        ],
                        column: 2
                    })                    
                ])
            ]
        });
    }

}